import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControlModule } from '@Work/Accounts/proprietary/controls/form-controls/form-control.module';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { AddressLookupSelectDialogComponent } from './address-lookup-select-dialog/address-lookup-select-dialog.component';
import { AddressSelectDialogComponent } from './address-select-dialog/address-select-dialog.component';
import { CitySelectDialogComponent } from './city-select-dialog.component';

@NgModule({
    imports: [SharedPageModule, NgbTooltipModule, FormControlModule],
    declarations: [CitySelectDialogComponent, AddressSelectDialogComponent, AddressLookupSelectDialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SelectionDialogModule { }
